import SalesReport from '@/pages/SalesReport';

export default function MobileSalesReportScreen() {
  return <SalesReport />;
}

